import { observer } from 'mobx-react-lite'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'
import { usePostPreviewStore } from 'components/PostPreviewModalV2/PostPreviewStoreProvider'

import { Section } from '../Section/Section'
import { ConnectionNeededItem } from './ConnectionNeededItem/ConnectionNeededItem'
import Styles from './ConnectionNeeded.module.scss'

interface ConnectionNeededViewProps {
  providers: ExternalIntegrationEnum[]
  onConnect: (p: ExternalIntegrationEnum) => void
  onRemove: (p: ExternalIntegrationEnum) => void
}

const ConnectionNeededView = ({ providers, onConnect, onRemove }: ConnectionNeededViewProps) => (
  <div className={Styles.root}>
    {providers.map((p) => (
      <ConnectionNeededItem key={p} provider={p} onConnect={() => onConnect(p)} onRemove={() => onRemove(p)} />
    ))}
  </div>
)

export const ConnectedConnectionNeeded = observer(
  ({ onConnect }: { onConnect: (p: ExternalIntegrationEnum) => void }) => {
    const store = usePostPreviewStore()
    const { data } = useBrandKit(store.selectedBrandKitId)

    if (!data?.brand_kit) return null

    const existing = data?.brand_kit?.external_integrations.map((i) => i.provider) ?? []
    const need = [...store.selectedChannels].filter((p) => !existing.includes(p))

    if (need.length === 0) return null

    return (
      <Section title="Need Connection">
        <ConnectionNeededView providers={need} onConnect={onConnect} onRemove={(p) => store.removeChannel(p)} />
      </Section>
    )
  },
)
